import { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { setCheckout } from "src/features/checkout/checkoutSlice"
import {
  useGetAvailableShippingRatesMutation,
  useUpdateShippingLineMutation,
} from "src/features/checkout/storefrontApi"

const useUpdateShippingLine = () => {
  const dispatch = useDispatch()
  const checkout = useSelector((state) => state.checkout.checkout)

  const [
    getAvailableShippingRates,
    {
      data: getAvailableShippingRatesData,
      isLoading: getAvailableShippingRatesLoading,
    },
  ] = useGetAvailableShippingRatesMutation()

  const [
    updateShippingLineMutation,
    {
      data: updateShippingLineData,
      error: updateShippingLineError,
      isLoading: updateShippingLineLoading,
    },
  ] = useUpdateShippingLineMutation()

  const updateShippingLine = () =>
    getAvailableShippingRates({
      checkoutId: checkout.id,
    })

  useEffect(() => {
    if (getAvailableShippingRatesData) {
      if (
        !getAvailableShippingRatesData?.node?.ready ||
        !getAvailableShippingRatesData?.node?.availableShippingRates?.ready
      ) {
        // Refetch if checkout or availableShippingRates is not yet ready.
        getAvailableShippingRates({
          checkoutId: checkout.id,
        })
      } else {
        dispatch(setCheckout(getAvailableShippingRatesData.node))

        // Find the best rate (cheapest price).
        let bestRate = null
        let cheapestPrice = Infinity

        for (const rate of getAvailableShippingRatesData.node
          .availableShippingRates.shippingRates) {
          const amount = parseFloat(rate.price.amount)

          if (amount < cheapestPrice) {
            bestRate = rate
            cheapestPrice = amount
          }
        }

        if (bestRate) {
          // Automatically select the best rate.
          updateShippingLineMutation({
            checkoutId: checkout.id,
            shippingRateHandle: bestRate.handle,
          })
        }
      }
    }
  }, [getAvailableShippingRatesData])

  useEffect(() => {
    if (updateShippingLineData?.checkoutShippingLineUpdate?.checkout) {
      dispatch(
        setCheckout(updateShippingLineData.checkoutShippingLineUpdate.checkout),
      )
    }
  }, [updateShippingLineData])

  return [
    updateShippingLine,
    {
      isLoading: getAvailableShippingRatesLoading || updateShippingLineLoading,
      data: updateShippingLineData,
      error: updateShippingLineError,
    },
  ]
}

export default useUpdateShippingLine
